module.exports = __webpack_public_path__ + "static/img/weChatCode.9da3053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/weChatCode.png
// module id = QObO
// module chunks = 1